/**
 * Child Theme - Scripts
 * File: custom-javascript.js
 * Description: file Js principale para el tema Child, qui vengono inizializzati i moduli js.
 *
 */

import StickyNavbar from "./modules/sticky-navbar.js";
import { initGallerySlider } from "./modules/gallery-slider.js";

jQuery(document).ready(function ($) {
  console.log("Theme Child NETCOOP 2025 → DOM pronto 👍");

  // Inizializza la Navbar sticky
  StickyNavbar.initialize("mainNavbar");

  // Inizializza lo gallery slider, attivato solo se necessario
  initGallerySlider();
});
